import { render } from "./single-otp-input.vue?vue&type=template&id=64eda560&scoped=true&ts=true"
import script from "./single-otp-input.vue?vue&type=script&lang=ts"
export * from "./single-otp-input.vue?vue&type=script&lang=ts"

import "./single-otp-input.vue?vue&type=style&index=0&id=64eda560&scoped=true&lang=scss"

import exportComponent from "/srv/loq/temp/Admin-Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64eda560"]])

export default __exports__